/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import RegularTemplate from '@/components/templates/RegularTemplate'
import { useFetchItemsWithParamsV2 } from '@/hooks/fetch/useFetchItemsWithParamsV2'
import {
  MANAGE_SAM_LISTING_DESCRIPTION,
  LIST_SAMS_FOR_LICENSING_TITLE
} from '@/configs/strings/manage-sam-listings'
import ItemsPagination from '@/components/wrappers/general/ItemsPagination'
import { Flex } from '@chakra-ui/react'
import { getCompaniesWithAiUsageLicense } from '@/services/sams'
import SingleManage from './components/SingleManage'

const ManageSamListings = () => {
  const {
    itemsResponse,
    loading
  } = useFetchItemsWithParamsV2({
    fetchService: getCompaniesWithAiUsageLicense,
    fetchParams: { orderField: 'name', orderType: 'desc' }
  })
  return (
    <RegularTemplate
      title={LIST_SAMS_FOR_LICENSING_TITLE}
      loadingContent={loading}
      description={MANAGE_SAM_LISTING_DESCRIPTION}
    >
      <ItemsPagination
        items={itemsResponse?.companies}
        totalItems={itemsResponse?.companies?.length}
      >
        { itemsResponse &&
          <Flex flexDirection="column" gap="20px">
            { itemsResponse.companies.map(company => (
              <SingleManage
                key={company.id}
                id={company.id}
                isListed={true}
                companyName={company.name}
                totalSams={company.counts.total}
                licensesSold={0}
                licensesUsed={0}
                pendingDeals={company.counts.pending}
                totalCreatedSams={company.counts.created}
                earned={0}
                companyLogo={company.logoUrl}
                aiAllowed={company.llmTags}
                coverUrls={company.coverUrls}
              />
            ))}
          </Flex>
        }
      </ItemsPagination>
    </RegularTemplate>
  )
}

export default ManageSamListings
